import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const complianceHoldReleaseAtom = createMutationAtomFactory(
  'trade.complianceHoldRelease',
  (params: { id: string; notes: string }) => ({
    tradeComplianceHoldRelease: {
      __args: {
        id: params.id,
        input: {
          notes: params.notes,
        },
      },
      id: true,
      status: true,
      releasedAt: true,
    },
  }),
);
